import { Recipient } from '@app/modules/client/shared/pipes/recipients.pipe'
import { Sort } from '@angular/material/sort'
import { ReportTypes } from '@shared/models/reports/types'
import { FilterValues } from '@shared/models/filter-values.model'
import { Timezone } from './timezone.model'

export interface ScheduleReportIntervalType {
  day?: number[]
  period?: string[]
}

export interface ScheduleReportInterval {
  type: {
    daily: ScheduleReportIntervalType
    weekly: ScheduleReportIntervalType
    monthly: ScheduleReportIntervalType
  }
  time: string[]
}

export interface ScheduledReportTemplate {
  interval: ScheduleReportInterval
  type: string[]
}

export interface ScheduledParams {
  [param: string]: string | number | (string | number)[]
  sort?: string
  fields?: string[]
}

export interface ScheduledParamsParse {
  filterValues: FilterValues
  sortValue: Sort
  fields: string[]
}

interface ScheduledReportInterval {
  type: string
  time: string
  period: string
  day: string
}

export interface ScheduledReportModel {
  id?: string
  type: ReportTypes
  eventId?: number
  name: string
  interval: ScheduledReportInterval
  format: string
  recipients: Recipient[]
  params?: ScheduledParams
  status?: ScheduledReportStatus
  updatedAt?: string
  createdAt?: string
  hasXlsx?: boolean
  timezone: number | Timezone
}

export interface ScheduledReportModelForm extends Omit<ScheduledReportModel, 'recipients'> {
  recipients: Recipient
}

export enum ScheduledReportStatus {
  Active = 'active',
  Deleted = 'deleted',
  Disabled = 'disabled',
}
